"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));
var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));
var _BufferSettings = _interopRequireDefault(require("./BufferSettings"));
var _ChannelInfo = _interopRequireDefault(require("./ChannelInfo"));
var _ChannelBanlist = _interopRequireDefault(require("./ChannelBanlist"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _default = exports.default = {
  components: {
    BufferSettings: _BufferSettings.default,
    ChannelInfo: _ChannelInfo.default,
    ChannelBanlist: _ChannelBanlist.default,
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: ['buffer', 'sidebarState'],
  data() {
    return {
      self: this,
      pluginUiChannelElements: _GlobalApi.default.singleton().channelHeaderPlugins,
      pluginUiQueryElements: _GlobalApi.default.singleton().queryHeaderPlugins
    };
  },
  computed: {
    isJoined() {
      let buffer = this.buffer;
      return buffer.getNetwork().state === 'connected' && buffer.joined;
    },
    isConnected() {
      return this.buffer.getNetwork().state === 'connected';
    },
    shouldShowTopic() {
      return !this.$state.ui.is_narrow && this.buffer.topic.trim() && this.buffer.setting('show_topic_in_header');
    },
    formattedTopic() {
      let blocks = (0, _MessageParser.default)(this.buffer.topic, {
        extras: false
      });
      let content = (0, _Html.default)(blocks);
      return content;
    },
    network() {
      return this.buffer.getNetwork();
    },
    sidebarSection() {
      return this.sidebarState.section();
    },
    userOnline() {
      let user = this.$state.getUser(this.buffer.getNetwork().id, this.buffer.name);
      return !!user;
    }
  },
  methods: {
    isChannel() {
      return this.buffer.isChannel();
    },
    isServer() {
      return this.buffer.isServer();
    },
    isQuery() {
      return this.buffer.isQuery();
    },
    isSpecial() {
      return this.buffer.isSpecial();
    },
    showNetworkSettings(network) {
      network.showServerBuffer('settings');
    },
    onConnectButtonClick() {
      let network = this.buffer.getNetwork();
      if (!network.connection.server) {
        network.showServerBuffer('settings');
      } else {
        network.ircClient.connect();
      }
    },
    toggleUser() {
      let user = this.$state.getUser(this.buffer.getNetwork().id, this.buffer.name);
      this.sidebarState.toggleUser(user);
    },
    joinCurrentBuffer() {
      let network = this.buffer.getNetwork();
      this.buffer.enabled = true;
      network.ircClient.join(this.buffer.name);
    },
    closeCurrentBuffer() {
      this.$state.removeBuffer(this.buffer);
    },
    onHeaderClick(event) {
      let channelName = event.target.getAttribute('data-channel-name');
      if (channelName) {
        let network = this.buffer.getNetwork();
        this.$state.addBuffer(this.buffer.networkid, channelName);
        network.ircClient.join(channelName);
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ContainerHeader"]
window._kiwi_exports.components.ContainerHeader = exports.default ? exports.default : exports;
